import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SWRConfig } from "swr";

import AccountProvider from './context/AccountProvider';
import LiveLoansProvider from './context/LiveLoansProvider';
import ArrangementProvider from './context/ArrangementProvider';
import AuthProvider from './context/AuthProvider';
import ClientProvider from './context/ClientProvider';
import CookieProvider from './context/CookieProvider';
import NavProvider from './context/NavProvider';
import PartyProvider from './context/PartyProvider';
import SfsProvider from './context/SfsProvider';
import UtilsProvider from './context/UtilsProvider';
import ProfileProvider from './context/ProfileProvider';
import CallMeProvider from './context/CallMeProvider';
import NotificationsProvider from './context/NotificationsProvider';
import AccessibilityProvider from './context/AccessibilityProvider';
import { AnalyticsProvider } from './context/AnalyticsProvider';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import DocumentsProvider from './context/DocumentsProvider';

// Common fetcher function for SWR usage
const fetcher = ([url, options]) => fetch(url, options).then((res) => res.json());

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <SWRConfig value={{ fetcher: fetcher }}>
    <UtilsProvider>
      <ClientProvider>
        <AuthProvider>
          <CookieProvider>
            <ProfileProvider>
              <NotificationsProvider>
                <AccountProvider>
                  <LiveLoansProvider>
                    <PartyProvider>
                      <SfsProvider>
                        <ArrangementProvider>
                          <NavProvider>
                            <CallMeProvider>
                              <AccessibilityProvider>
                                <DocumentsProvider>
                                  <AnalyticsProvider>
                                    <App />
                                  </AnalyticsProvider>
                                </DocumentsProvider>
                              </AccessibilityProvider>
                            </CallMeProvider>
                          </NavProvider>
                        </ArrangementProvider>
                      </SfsProvider>
                    </PartyProvider>
                  </LiveLoansProvider>
                </AccountProvider>
              </NotificationsProvider>
            </ProfileProvider>
          </CookieProvider>
        </AuthProvider>
      </ClientProvider>
    </UtilsProvider>
  </SWRConfig>
);